
/**
 * Created by a on 2016/9/30.
 */
const accountType = (Vue) => {
  Vue.directive('account-type', {
    update: function (value) {
      const account = window.session.getObj(window.sessionKeys.ACCOUNT);
      const perm = account.accountType;
      if ((perm & parseInt(value, 2)) !== perm) {
        $(this.el).remove();
      }
    }
  });
};
const organizationType = (Vue) => {
  Vue.directive('organization-type', {
    update: function (value) {
      var organization = window.session.getObj(window.sessionKeys.ORGANIZATION);
      var roleId = 1;
      if (organization) {
        roleId = organization.parsedRoleId;
      }
      if ((roleId & parseInt(value, 2)) !== roleId) {
        $(this.el).remove();
      }
    }
  });
};
export default {accountType,organizationType};



// WEBPACK FOOTER //
// ./src/managers/vue_extend/permission.js